import React, { useEffect, useState, useRef, useContext } from 'react';
import { Button, Select, DatePicker, Table } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import config from '../../../Config';
import calc from '../calc.js';
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/date-picker/locale/zh_CN';
import en_US from 'antd/lib/date-picker/locale/en_US';
import { useTranslation } from 'react-i18next';
import { SEnergyColumns } from './DataHistory-Columns-SEnergy';
import { SungeryColumns } from './DataHistory-Columns-Sungery';
import { ThinkpowerColumns } from "./DataHistory-Columns-Thinkpower.js";
import {MegarevoOrSinexcelColumns, setProtocolAndModel } from "./DataHistory-Columns-MegareveOrSinexcel.js";

function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().top
    }
    let height = `calc(100vh - ${tHeaderBottom + 100}px)`
    return height
}

function DataHistory(props) {
    const { t, i18n } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, model, protocol, handleSelectSN } = props
    const setTip = useContext(utils.tipContext)

    const [dataHistoryDate, setDataHistoryDate] = useState(moment().format('YYYY-MM-DD')) //时间
    const [aWeekAgoDate, setAWeekAgoDate] = useState(moment().subtract(7, 'days').format('YYYY-MM-DD'))  //一周前的日期, 导出用

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(100)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [columns, setColumns] = useState([])
    const [columnsStr, setColumnsStr] = useState("")
    const [dataIndices, setDataIndices] = useState([])


    const refDownloader1 = useRef(null)
    const refDownloader2 = useRef(null)

    const [scrollY, setScrollY] = useState("")

    setProtocolAndModel(protocol, model);

    useEffect(() => {
        setScrollY(getTableScroll())
    }, [])

    useEffect(()=>{
        let cls;
        if (protocol == "Sungery") {
            cls = SungeryColumns.map(col => ({...col}));
        } else if (protocol == "Thinkpower") {
            cls = ThinkpowerColumns.map(col => ({...col}));
        } else if (protocol == "Megarevo" || protocol == "Megarevo-CESS" || protocol == "Sinexcel") {
            cls = MegarevoOrSinexcelColumns.map(col => ({...col}));
        } else {
            cls = SEnergyColumns.map(col => ({...col}));
        }
        if (! cls) {
            return;
        }
        let is = cls.map((v) => v.dataIndex)
        setDataIndices(is)
        cls = [{
            title: "",
            width: 70,
            fixed: 'left',
            render: (v, r, idx) => {
                return (pageNo * pageSize + idx + 1);
            }
        }, ...cls];
        cls.forEach(c => { 
            c.title = t(c.title) 
        });
        setColumns(cls);
        let strColumns = [];
        for (let i = 0; i < cls.length; i++) {
            const c = cls[i];
            if (c.dataIndex) {
                strColumns.push({
                    title: c.title,
                    dataIndex: c.dataIndex,
                    transform: c.transform,
                    width: c.width,
                });
            }
        }
        setColumnsStr(encodeURIComponent(JSON.stringify(strColumns)));
    }, [protocol, SN, i18n.language])

    //取历史数据
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("integrated-inverter/history/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                SerialNumber: SN,
                STime: moment(dataHistoryDate).format("YYYY-MM-DD"),
                ETime: moment(dataHistoryDate).add(1, "days").format("YYYY-MM-DD"),
                DataIndices: dataIndices.join(',')
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setRowTotal(0)
                setRows([])
                return;
            }
            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, SN, dataHistoryDate]);

    const handleExport = () => {
        if (!refDownloader1.current) {
            return;
        }
        refDownloader1.current.click()
    }

    const handleExportWeek = () => {
        if (!refDownloader2.current) {
            return;
        }
        refDownloader2.current.click()
    }


    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: "none", padding: "10px" }}>
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t('Enter Inverter Name')}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px', marginLeft: '10px' }}
                >{inverterSelectOptions}</Select>
                <DatePicker
                    defaultValue={moment()}
                    value={moment(dataHistoryDate)}
                    onChange={(_, ds) => {
                        setDataHistoryDate(ds)
                        setAWeekAgoDate(moment(ds).subtract(7, 'days').format('YYYY-MM-DD'))
                    }}
                    allowClear={false}
                    locale={i18n.language === 'zh' ? zh_CN : en_US}
                />

                {/* <Button type="primary" disabled={rows.length < 1 ? true : false} onClick={handleExportWeek} style={{ float: 'right', marginRight: '10px', backgroundColor: '#0486be', color: '#fff' }}>{t('Export Data')}({dataHistoryDate} - {aWeekAgoDate})</Button> */}
                <Button type="primary" disabled={rows.length < 1 ? true : false} onClick={handleExport} style={{ float: 'right', marginRight: '10px', backgroundColor: '#0486be', color: '#fff' }}>{t('Export Data')}</Button>
            </div>
            <div style={{ flex: "auto", overflow: "hidden" }}>
                <Table
                    columns={columns}
                    pagination={{
                        pageSizeOptions: [25, 50, 100],
                        current: pageNo + 1,
                        pageSize: pageSize,
                        total: rowTotal,
                        showSizeChanger: true,
                        showTotal: (total) => { return t('Total {{total}}', { total }) },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                        },
                        onChange: (page, pageSize) => {
                            setPageNo(page - 1);
                        }
                    }}
                    tableLayout="fixed"
                    bordered={true}
                    size="small"
                    loading={loading}
                    rowKey="ID"
                    dataSource={rows}
                    scroll={{ x: 'max-content', y: scrollY }}
                >
                </Table>
            </div>

            <a ref={refDownloader1} style={{ display: "none" }} href={config.apiUrl + "data-export/inverter/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&STime=" + dataHistoryDate + "&ETime=" + moment(dataHistoryDate).add(1, 'days').format('YYYY-MM-DD') + "&Columns=" + columnsStr}></a>
            {/* <a ref={refDownloader2} style={{ display: "none" }} href={config.apiUrl + "data-export/inverter/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&STime=" + aWeekAgoDate + "&ETime=" + dataHistoryDate}></a> */}
        </div>
    )
}

export default DataHistory;